import React, { useEffect, useReducer, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { DEFAULT_THEME } from '../theme';
import { applyTheme } from '../theme/utils';
import EditorContext from '../store/Editor.context';
import editorReducer, { initialState, startSession } from '../store';
import { STORAGE } from '../constants';
import { hasValidToken } from '../utils/helpers';
import 'react-toastify/dist/ReactToastify.css'; // import '../styles/main.scss';

var initializer = function initializer(state) {
  return state;
};

var EditorProvider = function EditorProvider(_ref) {
  var children = _ref.children;

  var _useReducer = useReducer(editorReducer, initialState, initializer),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  useEffect(function () {
    if (state.authToken) {
      var uploadedFile = localStorage.getItem(STORAGE.uploadedFile);

      if (uploadedFile && hasValidToken()) {
        dispatch(startSession({
          uploadedFile: uploadedFile
        }));
      }
    }
  }, []);

  var _useState = useState(DEFAULT_THEME),
      theme = _useState[0];

  useEffect(function () {
    applyTheme(theme);
  }, [theme]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToastContainer, {
    toastClassName: "p-0 rounded shadow-xl",
    bodyClassName: "p-4 shadow-xs rounded-lg overflow-hidden"
  }), /*#__PURE__*/React.createElement(EditorContext.Provider, {
    value: {
      state: state,
      dispatch: dispatch
    }
  }, children));
};

export default EditorProvider;